import { Box, FormGroup, Image, Typography } from "@drone-js/core";
import { HStack } from "apps/commons/components/Stack";
import type { PayoutItem } from "libs/codegen/property-onboarding";
import type { FunctionComponent, PropsWithChildren } from "react";
import { getPayoutLabel } from "./getPayoutLabel";

interface Props extends PropsWithChildren {
    a11yGroup: string;
    title: string;
    icon?: string;
    items: PayoutItem[] | undefined;
    onSelect?: (item: PayoutItem) => void;
}

export const PayoutGroup: FunctionComponent<Props> = ({ items = [], a11yGroup, title, icon, onSelect }) => {
    return (
        <FormGroup
            role="group"
            as="ul"
            p="0"
            aria-labelledby={`group-${a11yGroup}`}
            display="flex"
            flexDirection="column"
        >
            <Box as="li" role="presentation" backgroundColor="base.inset" px="16" py="8">
                <Typography variant="caption-default-strong" textColor="base.subtle">
                    {title.toUpperCase()}
                </Typography>
            </Box>
            {items.map((item) => (
                <HStack
                    key={`payout-${item.method}-${item.id}`}
                    as="li"
                    role="option"
                    p="16"
                    cursor="pointer"
                    gap="12"
                    alignItems="center"
                    onClick={() => onSelect?.(item)}
                >
                    {icon && <Image src={icon} width="36px" height="auto" alt="icon" />}
                    <Typography variant="body-default-strong">{getPayoutLabel(item)}</Typography>
                </HStack>
            ))}
        </FormGroup>
    );
};
